"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoRooms/Room/Modals/JoinCall.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _VideoFeed = require('web/components/VideoCall/VideoFeed'); var _VideoFeed2 = _interopRequireDefault(_VideoFeed);


var _CallControls = require('web/components/VideoCall/CallControls');

var _LinkBar = require('web/components/VideoRooms/Room/LinkBar'); var _LinkBar2 = _interopRequireDefault(_LinkBar);
var _JoinMeetingBtnContent = require('web/components/VideoCall/JoinMeetingBtnContent'); var _JoinMeetingBtnContent2 = _interopRequireDefault(_JoinMeetingBtnContent);
var _WarningBar = require('web/components/WarningBar'); var _WarningBar2 = _interopRequireDefault(_WarningBar);
var _videoCall = require('web/services/videoCall');





















const streamWarnings = {
  incompatibleBrowser: {
    message: "Your current browser does not support video calls.",
  },
  noPerms: {
    message: "Please allow access to your microphone and camera.",
  },
  unknown: {
    message: "An unknown error has occurred.",
  },
}

const JoinCallModal = ({
  isOpen,
  onClose,
  roomName,
  roomLink,
  onRoomShare,
  onRoomLinkCopy,
  gotoSettings,
  gotoMeeting,
  isMicOn,
  isCamOn,
  isCamCycleAvailable,
  onCycleCam,
  onToggleCam,
  onToggleMic,
  stream = null,
  isBrowserCompatible,
  arePermsGranted,
}) => {
  const renderStream = () => (
    _react2.default.createElement('div', { className: "meeting-room--join-modal--feed-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
      , _react2.default.createElement(_VideoFeed2.default, {
        stream: stream,
        isVideoOn: isCamOn,
        shouldMirror: _videoCall.shouldMirrorCamFeed.call(void 0, stream),
        className: "meeting-room--join-modal--feed", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}
      )
      , _react2.default.createElement('div', { className: "meeting-room--join-modal--controls-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
        ,  isCamCycleAvailable &&
          _react2.default.createElement(_CallControls.SwitchCamBtn, {
            onClick: onCycleCam,
            className: "meeting-room--join-modal--control-button", __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}
          )
        
        , _react2.default.createElement(_CallControls.DisableCamBtn, {
          onClick: onToggleCam,
          className: "meeting-room--join-modal--control-button",
          isActive: !isCamOn, __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}
        )
        , _react2.default.createElement(_CallControls.DisableMicBtn, {
          onClick: onToggleMic,
          className: "meeting-room--join-modal--control-button",
          isActive: !isMicOn, __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}
        )
      )
    )
  )

  const renderStreamWarning = () => {
    const warning =
      !isBrowserCompatible && streamWarnings.incompatibleBrowser ||
      !arePermsGranted && streamWarnings.noPerms ||
      streamWarnings.unknown

    return (
      _react2.default.createElement('div', { className: "meeting-room--join-modal--stream-warning-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}
        , _react2.default.createElement(_WarningBar2.default, {
          className: "meeting-room--join-modal--stream-warning",
          text: warning.message, __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}
        )
      )
    )
  }

  const isStreamAvailable = isBrowserCompatible && arePermsGranted
  const buildBtnClassName = (...cs) =>
    _classBuilder2.default.call(void 0, { disabled: !isStreamAvailable }, cs)

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: isOpen,
      onClose: onClose,
      className: "meeting-room--join-modal",
      title: "Meeting Room" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 116}}

      , _react2.default.createElement('div', { className: "meeting-room--join-modal--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}}
        , _react2.default.createElement('h1', { className: "meeting-room--join-modal--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 123}},  roomName )
        , _react2.default.createElement('span', { className: "meeting-room--join-modal--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}, "You are ready to join the meeting."      )
      )
      ,  isStreamAvailable
        ? renderStream()
        : renderStreamWarning()
      
      ,  isBrowserCompatible &&
        _react2.default.createElement('div', { className: "meeting-room--join-modal--btns-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}}
          , _react2.default.createElement('a', {
            onClick: gotoMeeting,
            className: buildBtnClassName(
              "meeting--btn", "meeting-room--join-modal--proceed-btn",
            ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}}

            , _react2.default.createElement(_JoinMeetingBtnContent2.default, {
              isMicOn: isMicOn,
              isCamOn: isCamOn, __self: this, __source: {fileName: _jsxFileName, lineNumber: 138}}
            )
          )
          , _react2.default.createElement('a', {
            onClick: gotoSettings,
            className: buildBtnClassName(
              "meeting--btn", "secondary",
              "meeting-room--join-modal--back-btn",
            ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 143}}
, "Check settings"

          )
        )
      
      , _react2.default.createElement('div', { className: "meeting-room--join-modal--sharing", __self: this, __source: {fileName: _jsxFileName, lineNumber: 154}}
        , _react2.default.createElement(_LinkBar2.default, {
          link: roomLink,
          onShare: onRoomShare,
          onCopy: onRoomLinkCopy,
          className: "lg",
          iconClassName: "purple",
          isIconLabelShown: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 155}}
        )
        , _react2.default.createElement('span', { className: "meeting-room--join-modal--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 163}}, "Share this link with people you want in the meeting."

        )
      )
    )
  )
}

exports. default = JoinCallModal
